import { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { applyThemeDefault } from '@lineageatlas/design-system';
import {
  getClinicianScopedView,
  getDefaultDemoPhysician,
  getDemoPhysicians,
  type ClinicianOutletContext,
} from '../features/clinician';
import '../features/clinician/clinician.css';

export function ClinicianShell() {
  const physicians = useMemo(() => getDemoPhysicians(), []);
  const [physicianId, setPhysicianId] = useState(() => getDefaultDemoPhysician().id);
  const view = useMemo(() => getClinicianScopedView(physicianId), [physicianId]);
  const outletContext: ClinicianOutletContext = { view };

  useEffect(() => {
    applyThemeDefault('light');
  }, []);

  return (
    <div className="clinician-shell">
      <label className="clinician-demo-select">
        Demo physician
        <select
          id="clinician-demo-physician"
          name="clinician-demo-physician"
          value={physicianId}
          onChange={(event) => setPhysicianId(event.target.value)}
        >
          {physicians.map((physician) => (
            <option key={physician.id} value={physician.id}>
              {physician.name}
            </option>
          ))}
        </select>
      </label>

      <main className="clinician-main">
        <Outlet context={outletContext} />
      </main>
    </div>
  );
}
